import http from 'Services/HttpService';

import { baseUrl } from 'Utils/envLoader';

const AccessService = {
    getAppById: (id) => {
        return http.get(`${baseUrl}/cliami/apps/${id}`);
    },

    getApps: () => {
        return http.get(`${baseUrl}/cliami/apps`);
    },

    saveApp: (form, appId) => {
        if (!appId) {
            return http.post(`${baseUrl}/cliami/apps/create`, form, {
                headers: {
                    ContentType: 'multipart/form-data',
                },
            });
        } else {
            return http.put(`${baseUrl}/cliami/apps/update/${appId}`, form, {
                headers: {
                    ContentType: 'multipart/form-data',
                },
            });
        }
    },
    getByUserIdAndAppId: (appId) => {
        return http.get(`${baseUrl}/cliami/accesses/user-app/${appId}`);
    },

    deleteApp: (app) => {
        return http.get(`${baseUrl}/cliami/apps`, app);
    },
};

export default AccessService;
